import React, { useState, useEffect } from "react";
import DashboardSpanSelect from "../DashboardSpanSelect/DashboardSpanSelect";
import { Checkbox, Popover, Skeleton, Spin } from "antd";
import styles from "./index.module.scss";
import DoughnutChart from "../Charts/DoughnutChart/DoughnutChart";
import moment from "moment";
import BarChart from "../Charts/BarChart/BarChart";
import GenderGraph from "../Charts/GenderGraph/GenderGraph";
import { fetchLatestAppointments, fetchLatestRequestedAppointments, fetchConsolidatedAnalytics } from "../../../../actions/InterbranchAdminActions";
import { useDispatch } from "react-redux";
import EmptyTableData from "../../../Common/EmptyTableData/EmptyTableData";
import AppDatePicker from "../../../UI/app-date-picker/AppDatePicker";

const REPORT_TYPE_ENUMS = {
	PIE: "PIE",
	BAR: "BAR",
	LINE: "LINE",
	TABLE: "TABLE",
	LIST: "LIST",
	GENDER: "GENDER",
};

const DataContent = ({ context = "REQUESTS", dashboardItemsList, handleViewMoreAppointmentRequest, handleViewMoreDailyAppointments }) => {
	const [selectedDashboardComponents, setSelectedDashboardComponents] = useState(dashboardItemsList);
	const [selectedSpan, setSelectedSpan] = useState("Weekly");
	const [latestAppointments, setLatestAppointments] = useState([]);
	const [latestRequestedAppointments, setLatestRequestedAppointments] = useState([]);
	const [consolidateData, setConsolidatedData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
  const [isAppointmentsLoading, setIsAppointmentsLoading] = useState(true);
	const [isRequestedAppointmentsLoading, setIsRequestedAppointmentsLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
        setIsAppointmentsLoading(true);
				// Await the function call to get the resolved data
				const response = await dispatch(fetchLatestAppointments());
				console.debug("response", response);

				// Ensure state updates with actual data
				setLatestAppointments(response);
        setIsAppointmentsLoading(false);
			} catch (error) {
				console.error(error);
        setIsAppointmentsLoading(false);
			}
		};

		fetchAppointments();
	}, [dispatch]);

	console.log("latestAppointments", latestAppointments);
	console.log("selectedSpan", selectedSpan);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
        setIsRequestedAppointmentsLoading(true);
				// Await the function call to get the resolved data
				const response = await dispatch(fetchLatestRequestedAppointments());
				console.debug("response", response);

				// Ensure state updates with actual data
				setLatestRequestedAppointments(response);
        setIsRequestedAppointmentsLoading(false);
			} catch (error) {
				console.error(error);
        setIsRequestedAppointmentsLoading(false);
			}
		};

		fetchAppointments();
	}, [dispatch]);

	useEffect(() => {
		const fetchAppointments = async () => {
			try {
				setIsLoading(true);
				// Call dispatch
				const response = await dispatch(fetchConsolidatedAnalytics(selectedSpan));
				console.debug("fetchConsolidatedAnalytics", response);
				setConsolidatedData(response);
				setIsLoading(false);
				console.log("consolidateData", consolidateData);
			} catch (error) {
				console.error(error);
				setIsLoading(false);
			}
		};
		fetchAppointments();
	}, [dispatch, selectedSpan]);

	// // Transform API data for top specialities
	// const getTopSpecialitiesData = () => {
	// 	if (!consolidateData?.topSpecialities) return null;

	// 	return {
	// 		x: "Speciality",
	// 		y: "Number of consultations",
	// 		data: consolidateData.topSpecialities.map((spec) => spec.consultations),
	// 		labels: consolidateData.topSpecialities.map((spec) => {
	// 			// Truncate long specialty names if needed
	// 			const maxLength = 25;
	// 			return spec.specialityName.length > maxLength ? spec.specialityName.substring(0, maxLength) + "..." : spec.specialityName;
	// 		}),
	// 	};
	// };

	// // Transform API data for top doctors
	// const getTopDoctorsData = () => {
	// 	if (!consolidateData?.topDoctors) return null;

	// 	return {
	// 		x: "Doctor name",
	// 		y: "Number of consultations",
	// 		data: consolidateData.topDoctors.map((doc) => doc.consultations),
	// 		labels: consolidateData.topDoctors.map((doc) => doc.doctorName.trim()),
	// 	};
	// };

	const analyticsData = {
		trafficSplitByPlatform: {
			labels: ["Web", "Android", "iOS"],
			datasets: [
				{
					label: "Traffic split by platform",
					data: [300, 50, 100],
					backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
				},
			],
		},
		latestRequestedAppointments: latestRequestedAppointments,
		latestAppointments: latestAppointments,
		totalPatients: {
			labels: ["New", "Old"],
			datasets: [
				{
					data: [300, 50],
					backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
				},
			],
		},
		locationSplit: {
			labels: ["Kolkata", "Delhi", "Mumbai", "Chennai"],
			datasets: [
				{
					data: [300, 50, 100, 200],
					backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
				},
			],
		},
		appointmentStatus: {
			labels: ["Confirmed", "Pending", "Cancelled"],
			datasets: [
				{
					// data: [300, 50, 100],
					data: [300, 50, 100],
					backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
				},
			],
		},
		gender: {
			male: {
				percentage: 79,
				count: 79,
			},
			female: {
				percentage: 10,
				count: 10,
			},
			other: {
				percentage: 11,
				count: 11,
			},
		},
		age: {
			x: "Age group",
			y: "Number of patients",
			labels: ["Children and adolescents (0-18)", "Young adults (19-30)", "Early adulthood (31-40)", "Midlife (41-50)", "Pre-senior (51-60)", "Senior adults (60-70)", "Older seniors (71-80)", "Elderly (80+)"],
			data: [300, 50, 100, 200, 300, 400, 500, 600],
		},
		appointmentType: {
			labels: ["First Time", "Follow up"],
			datasets: [
				{
					data: [300, 50],
					backgroundColor: ["#FF6384", "#36A2EB"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB"],
				},
			],
		},
		requestElapsedTime: {
			labels: ["0-10 days", "10-20 days", "30-30 days", "More than a month"],
			datasets: [
				{
					data: [300, 50, 100, 200],
					backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
				},
			],
		},
		inprogressReason: {
			labels: ["Doctor not available", "Patient not available"],
			datasets: [
				{
					data: [300, 50],
					backgroundColor: ["#FF6384", "#36A2EB"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB"],
				},
			],
		},
		rejectedList: {
			labels: ["Doctor not available", "Patient not available"],
			datasets: [
				{
					data: [300, 50],
					backgroundColor: ["#FF6384", "#36A2EB"],
					hoverBackgroundColor: ["#FF6384", "#36A2EB"],
				},
			],
		},
	};

	const consolidatedData = {
		topDoctors: {
			x: "Doctor name",
			y: "Number of consultations",
			data: consolidateData?.topDoctors?.map((doc) => doc.consultations) || [],
			labels: consolidateData?.topDoctors?.map((doc) => doc.doctorName) || [],
			hoverLabels: consolidateData?.topDoctors?.map((doc) => doc.doctorFullName) || [],
		},
		topSpecialities: {
			x: "Speciality",
			y: "Number of consultations",
			data: consolidateData?.topSpecialities?.map((spec) => spec.consultations) || [],
			labels: consolidateData?.topSpecialities?.map((spec) => spec.specialityName) || [],
		},
		pendingFor: consolidateData?.pendingFor
			? {
					labels: ["0-10 days", "10-20 days", "20-30 days"],
					datasets: [
						{
							data: [
								consolidateData.pendingFor.uptoTen,
								consolidateData.pendingFor.uptoTwenty,
								consolidateData.pendingFor.uptoThirty,
								// consolidateData.pendingFor.moreThanAMonth,
							],
							backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
						},
					],
			  }
			: null,
		apptReqStatusCount: consolidateData?.apptReqStatusCount
			? {
					labels: ["Accepted", "In Progress", "Rejected", "Pending"],
					datasets: [
						{
							label: "Appointment Request Status",
							data: [consolidateData.apptReqStatusCount.acceptedCount, consolidateData.apptReqStatusCount.inProgressCount, consolidateData.apptReqStatusCount.rejectCount, consolidateData.apptReqStatusCount.pendingCount],
							backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
						},
					],
			  }
			: null,
      inProgressStatusCount: consolidateData?.inProgressStatusCount
      ? {
          labels: Object.keys(consolidateData.inProgressStatusCount),
          datasets: [
            {
              label: "In Progress Status Count",
              data: Object.values(consolidateData.inProgressStatusCount),
              backgroundColor: ["#FF6384", "#FF9800", "#E74C3C", "#9B59B6", "#1ABC9C", "#F7DC6F"],
              hoverBackgroundColor: ["#FF6384", "#FF9800", "#E74C3C", "#9B59B6", "#1ABC9C", "#F7DC6F"],
            },
          ],
        }
      : null,
    
		rejectReasonCount: consolidateData?.rejectReasonCount
			? {
					labels: Object.keys(consolidateData.rejectReasonCount),
					datasets: [
						{
							label: "Reject Reason Count",
							data: Object.values(consolidateData.rejectReasonCount),
							backgroundColor: ["#8BC34A", "#FF69B4", "#FFCE56", "#03A9F4", "#FF6384", "#00BCD4", "#F44336", "#9C27B0", "#4CAF50", "#673AB7", "#FF9800", "#E91E63", "#009688", "#3F51B5", "#795548"],
							hoverBackgroundColor: ["#8BC34A", "#FF69B4", "#FFCE56", "#03A9F4", "#FF6384", "#00BCD4", "#F44336", "#9C27B0", "#4CAF50", "#673AB7", "#FF9800", "#E91E63", "#009688", "#3F51B5", "#795548"],
						},
					],
			  }
			: null,

		patientCountApptReq: consolidateData?.patientCountApptReq
			? {
					labels: ["New Patients", "Existing Patients"],
					datasets: [
						{
							label: "Patient Count for Appointment Requests",
							data: [
								consolidateData.patientCountApptReq.newPatientCount || consolidateData.patientCountApptReq.newPatientCountReq,
								consolidateData.patientCountApptReq.existingPatientCount || consolidateData.patientCountApptReq.existingPatientCountReq,
							],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		patientLocationRequests: consolidateData?.patientLocationRequests
			? {
					labels: ["Domestic", "International"],
					datasets: [
						{
							label: "Patient Location Requests",
							data: [consolidateData.patientLocationRequests.domestic, consolidateData.patientLocationRequests.international],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		genderApptRequest: consolidateData?.genderApptRequest
			? (() => {
					const { Male = 0, Female = 0, otherReq = 0 } = consolidateData.genderApptRequest;
					const total = Male + Female + otherReq || 1;

					return {
						male: {
							percentage: (Male / total) * 100,
							count: Male,
						},
						female: {
							percentage: (Female / total) * 100,
							count: Female,
						},
						other: {
							percentage: (otherReq / total) * 100,
							count: otherReq,
						},
					};
			  })()
			: null,

		ageGroupApptRequest: consolidateData?.ageGroupApptRequest
			? {
					x: "Age Group",
					y: "Number of Patients",
					labels: ["Children and adolescents (0-18)", "Young adults (19-30)", "Early adulthood (31-40)", "Midlife (41-50)", "Pre-senior (51-60)", "Senior adults (60-70)", "Older seniors (71-80)", "Elderly (80+)"],
					data: [
						consolidateData.ageGroupApptRequest.children,
						consolidateData.ageGroupApptRequest.youngAdults,
						consolidateData.ageGroupApptRequest.adulthood,
						consolidateData.ageGroupApptRequest.midlife,
						consolidateData.ageGroupApptRequest.preSenior,
						consolidateData.ageGroupApptRequest.seniorAdults,
						consolidateData.ageGroupApptRequest.olderSenior,
						consolidateData.ageGroupApptRequest.elderly,
					],
			  }
			: null,
		apptType: consolidateData?.apptType
			? {
					labels: ["First Time", "Follow Up"],
					datasets: [
						{
							label: "Appointment Type",
							data: [consolidateData.apptType.firstTime, consolidateData.apptType.followUp],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		apptTypeReq: consolidateData?.apptTypeReq
			? {
					labels: ["First Time", "Follow Up"],
					datasets: [
						{
							label: "Appointment Type",
							data: [consolidateData.apptTypeReq.firstTimeReq, consolidateData.apptTypeReq.followUpReq],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		ageGroupApptmns: consolidateData?.ageGroupApptmns
			? {
					x: "Age Group",
					y: "Number of Patients",
					labels: ["Children and adolescents (0-18)", "Young adults (19-30)", "Early adulthood (31-40)", "Midlife (41-50)", "Pre-senior (51-60)", "Senior adults (60-70)", "Older seniors (71-80)", "Elderly (80+)"],
					data: [
						consolidateData.ageGroupApptmns.children,
						consolidateData.ageGroupApptmns.youngAdults,
						consolidateData.ageGroupApptmns.adulthood,
						consolidateData.ageGroupApptmns.midlife,
						consolidateData.ageGroupApptmns.preSenior,
						consolidateData.ageGroupApptmns.seniorAdults,
						consolidateData.ageGroupApptmns.olderSenior,
						consolidateData.ageGroupApptmns.elderly,
					],
			  }
			: null,
		genderApptmns: consolidateData?.genderApptmns
			? {
					male: {
						percentage: (consolidateData.genderApptmns.male / (consolidateData.genderApptmns.male + consolidateData.genderApptmns.female + consolidateData.genderApptmns.other)) * 100,
						count: consolidateData.genderApptmns.male,
					},
					female: {
						percentage: (consolidateData.genderApptmns.female / (consolidateData.genderApptmns.male + consolidateData.genderApptmns.female + consolidateData.genderApptmns.other)) * 100,
						count: consolidateData.genderApptmns.female,
					},
					other: {
						percentage: (consolidateData.genderApptmns.other / (consolidateData.genderApptmns.male + consolidateData.genderApptmns.female + consolidateData.genderApptmns.other)) * 100,
						count: consolidateData.genderApptmns.other,
					},
			  }
			: null,

		patientLocationApptmns: consolidateData?.patientLocationApptmns
			? {
					labels: ["Domestic", "International"],
					datasets: [
						{
							label: "Patient Location",
							data: [consolidateData.patientLocationApptmns.domestic, consolidateData.patientLocationApptmns.international],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		patientCount: consolidateData?.patientCount
			? {
					labels: ["New Patients", "Existing Patients"],
					datasets: [
						{
							label: "New/ Existing Patients",
							data: [consolidateData.patientCount.newPatientCount, consolidateData.patientCount.existingPatientCount],
							backgroundColor: ["#FF6384", "#36A2EB"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
			  }
			: null,
		appointmentStatus: consolidateData?.appointmentStatus
			? {
					labels: Object.keys(consolidateData.appointmentStatus),
					datasets: [
						{
							label: "Appointment Status",
							data: Object.values(consolidateData.appointmentStatus),
							backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374", "#C2185B"],
							hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374", "#C2185B"],
						},
					],
			  }
			: null,
	};

	const deviceUsageData = {
		labels: ["Android", "iOS", "Mobile Web", "Web"],
		datasets: [
			{
				label: "Device Usage",
				data: [consolidateData.deviceUsage?.androidCount, consolidateData.deviceUsage?.iOSCount, consolidateData.deviceUsage?.mobileWebCount, consolidateData.deviceUsage?.webCount],
				backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
				hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#376374"],
			},
		],
	};

	const checkIfVisible = (item) => {
		return selectedDashboardComponents.includes(item);
	};

	const contextData = {
		REQUESTS: {
			gridReports: [
				{
					key: 6,
					data: consolidatedData.apptReqStatusCount,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 1,
				},
				{
					key: 12,
					data: consolidatedData.pendingFor,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 2,
				},
				
				{
					key: 13,
					data: consolidatedData.inProgressStatusCount,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 3,
				},
				{
					key: 14,
					data: consolidatedData.rejectReasonCount,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 4,
				},
				{
					key: 4,
					data: consolidatedData.patientCountApptReq,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 5,
				},
				{
					key: 5,
					data: consolidatedData.patientLocationRequests,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 6,
				},
				{
					key: 9,
					data: consolidatedData.genderApptRequest,
					type: REPORT_TYPE_ENUMS.GENDER,
					order: 7,
				},
				{
					key: 10,
					data: consolidatedData.ageGroupApptRequest,
					type: REPORT_TYPE_ENUMS.BAR,
					order: 8,
				},
				{
					key: 11,
					data: consolidatedData.apptTypeReq,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 9,
				},
			],
			tableReports: [
				{ key: 7, data: analyticsData.latestRequestedAppointments },
				{ key: 8, data: analyticsData.latestAppointments },
			],
		},
		CONFORMED: {
			gridReports: [
				{
					key: 3,
					data: consolidatedData.topSpecialities,
					type: REPORT_TYPE_ENUMS.BAR,
					order: 1,
				},
				{
					key: 2,
					data: consolidatedData.topDoctors,
					type: REPORT_TYPE_ENUMS.BAR,
					order: 2,
				},
				{
					key: 6,
					data: consolidatedData.appointmentStatus,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 3,
				},

        {
					key: 1,
					data: deviceUsageData,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 4,
				},

				{
					key: 4,
					data: consolidatedData.patientCount,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 5,
				},
				{
					key: 5,
					data: consolidatedData.patientLocationApptmns,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 6,
				},
				{
					key: 9,
					data: consolidatedData.genderApptmns,
					type: REPORT_TYPE_ENUMS.GENDER,
					order: 7,
				},
				{
					key: 10,
					data: consolidatedData.ageGroupApptmns,
					type: REPORT_TYPE_ENUMS.BAR,
					order: 8,
				},
				{
					key: 11,
					data: consolidatedData.apptType,
					type: REPORT_TYPE_ENUMS.PIE,
					order: 9,
				},
			],
			tableReports: [
				{ key: 7, data: analyticsData.latestRequestedAppointments },
				{ key: 8, data: analyticsData.latestAppointments },
			],
		},
	};

	// const handleViewMoreDailyAppointments = () => {};
	const onClickSelectItemCheckbox = (itemName, e) => {
		if (e.target.checked) {
			setSelectedDashboardComponents((prev) => [...prev, itemName]);
		} else {
			setSelectedDashboardComponents((prev) => prev.filter((eachItem) => eachItem !== itemName));
		}
	};

	const ListManager = (
		<>
			{contextData[context]?.gridReports.map((eachItem, key) => {
				const itemName = dashboardItemsList[eachItem.key];
				const isSelected = selectedDashboardComponents.includes(itemName);
				return (
					<p key={key}>
						<Checkbox
							checked={isSelected}
							value={isSelected}
							onChange={(e) => {
								onClickSelectItemCheckbox(itemName, e);
							}}
						>
							{itemName}
						</Checkbox>
					</p>
				);
			})}
		</>
	);

  	// Function to render table skeleton loader
	const renderTableSkeleton = () => {
		return (
			<>
				<thead>
					<tr>
						{Array(4).fill(0).map((_, index) => (
							<th key={index}>
								<Skeleton.Button active size="small" style={{ width: '100%', height: '20px' }} />
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{Array(5).fill(0).map((_, rowIndex) => (
						<tr key={rowIndex}>
							{Array(4).fill(0).map((_, colIndex) => (
								<td key={colIndex}>
									<Skeleton.Button active size="small" style={{ width: '100%', height: '20px' }} />
								</td>
							))}
						</tr>
					))}
				</tbody>
			</>
		);
	};

	return (
		<div className="w-100 d-flex flex-column gap-3 pb-3">
			<div className="d-flex justify-content-between align-items-center w-100 gap-2">
				<div className="d-flex flex-row align-items-center gap-2">
					{/* <AppDatePicker /> */}
					<DashboardSpanSelect value={selectedSpan} onChange={(value) => setSelectedSpan(value)} />
				</div>
				<Popover getPopupContainer={(triggerNode) => triggerNode.parentNode} content={ListManager} title="Select item(s) to show" trigger="click" placement="left">
					<button style={{ height: "40px", width: "40px", aspectRatio: "1" }} className="caption rounded-circle border-0 bg-transparent h6 p-0 m-0">
						<i class="fal fa-cog"></i>
					</button>
				</Popover>
			</div>

			<div className="w-100 d-flex flex-column gap-2">
				<div className={styles.threeDataContainer}>
					{isLoading
						? contextData[context].gridReports.map((eachReport, key) => {
								return (
									<Skeleton.Button
										shape="round"
										key={key}
										active
										style={{
											width: "100%",
											height: "340px",
											borderRadius: "12px",
										}}
									/>
								);
						  })
						: contextData[context].gridReports
								.sort((e) => e.order)
								.map((eachReport, key) => {
									const isVisible = checkIfVisible(dashboardItemsList[eachReport.key]);

									// Add a check for data existence
									const hasData =
										eachReport.data &&
										(eachReport.type === REPORT_TYPE_ENUMS.PIE
											? eachReport.data.datasets?.[0]?.data?.some((val) => val > 0)
											: eachReport.type === REPORT_TYPE_ENUMS.BAR
											? eachReport.data?.data?.some((val) => val > 0)
											: eachReport.type === REPORT_TYPE_ENUMS.GENDER
											? eachReport.data?.male?.count > 0 || eachReport.data?.female?.count > 0
											: true);

									if (isVisible && !eachReport.hidden && hasData) {
										return (
											<div className={styles.threeDataItem} key={key}>
												<div className={styles.threeDataItem_header}>
													<h5>{dashboardItemsList[eachReport.key]}</h5>
												</div>
												{renderGraph(eachReport.data, eachReport.type)}
											</div>
										);
									}
									return null;
								})}
				</div>

				<div className={styles.topDataTablContainer}>
					{checkIfVisible(dashboardItemsList[7]) ? (
						<div className={styles.topTableWrap}>
							<div className={styles.topTableWrap_header}>
								<h5>Appointment Requests (Latest 5)</h5>
								<span onClick={handleViewMoreAppointmentRequest}>View more</span>
							</div>

							<table className="w-100">
              					{isRequestedAppointmentsLoading ? (
									renderTableSkeleton()
								) : (
									<>
								<thead>
									<tr>
										<th>Request Id</th>
										<th>Appointment Date</th>
										<th>Department Name</th>
										<th>Patient name</th>
										{/* <th>Request Status</th> */}
									</tr>
								</thead>
								<tbody>
									{analyticsData.latestRequestedAppointments.map((eachAppointment, key) => {
										return (
											<tr key={key}>
												<td>{eachAppointment?.requestId || "NA"}</td>
												<td>{moment(eachAppointment?.apptDate, "DD/MM/YYYY").format("DD-MMM-YYYY") || "NA"}</td>
												<td>{eachAppointment?.specialityName || "NA"}</td>
												<td>{eachAppointment?.patientName || "NA"}</td>
												{/* <td>{eachAppointment?.requestStatus || "NA"}</td> */}
											</tr>
										);
									})}
								</tbody>
                </>
                )}
							</table>
						</div>
					) : null}

					{checkIfVisible(dashboardItemsList[8]) ? (
	<div className={styles.topTableWrap}>
		<div className={styles.topTableWrap_header}>
			<h5>Daily Appointments (Latest 5)</h5>
			<span onClick={handleViewMoreDailyAppointments} style={{ cursor: "pointer", display: "inline-block" }}>
				View more
			</span>
		</div>

		<table className="w-100">
			{isRequestedAppointmentsLoading ? (
				renderTableSkeleton()
			) : (
				<>
					<thead>
						<tr>
							<th>Appointment Id</th>
							<th>Appointment Time</th>
							<th>Doctor Name</th>
							<th>Patient name</th>
						</tr>
					</thead>
					<tbody>
						{analyticsData.latestAppointments.length === 0 ? (
							<tr>
								<td colSpan={4}>
									<EmptyTableData
										isLoading={false}
										haveButton={false}
										text={"LOOKS LIKE NO APPOINTMENT HAS BEEN CREATED YET"}
										caption={""}
									/>
								</td>
							</tr>
						) : (
							analyticsData.latestAppointments.map((eachAppointment, key) => (
								<tr key={key}>
									<td>{eachAppointment?.apptId || "NA"}</td>
									<td>
										<div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
											<span style={{ margin: "5px 0px" }}>{eachAppointment?.startTime || "NA"} (P)</span>
											<span style={{ margin: "5px 0px" }}>{eachAppointment?.doctorstartTime || "NA"} (D)</span>
										</div>
									</td>
									<td>{eachAppointment?.doctorName || "NA"}</td>
									<td>{eachAppointment?.patientName || "NA"}</td>
								</tr>
							))
						)}
					</tbody>
				</>
			)}
		</table>
	</div>
) : null}

				</div>
			</div>
		</div>
	);
};

export default DataContent;

const renderGraph = (data, type) => {
	switch (type) {
		case REPORT_TYPE_ENUMS.PIE:
			return <DoughnutChart data={data} />;
		case REPORT_TYPE_ENUMS.BAR:
			return <BarChart data={data?.data || []} labels={data?.labels || []} hoverLabels={data?.hoverLabels || []} x={data?.x} y={data?.y} />;
		case REPORT_TYPE_ENUMS.GENDER:
			return <GenderGraph {...data} />;
		// case REPORT_TYPE_ENUMS.LIST:
		//   return data?.map((eachSpeciality, key) => {
		//     return (
		//       <div key={key} className={styles.eachDoctorsItem}>
		//         <img
		//           alt="doctor"
		//           className={styles.dp}
		//           src={eachSpeciality?.specialityImage || ""}
		//         ></img>
		//         <div className={styles.detailsWrap}>
		//           <h6>{eachSpeciality?.specialityName}</h6>
		//           <span>{eachSpeciality.consultations} consultation per day</span>
		//         </div>
		//       </div>
		//     );
		//   });
		default:
			return "No graph available";
	}
};
